export const sysColor = {
  primary: '#8b60f0', // 主色
  text: '#333333', // 文字主色
}



// WEBPACK FOOTER //
// ./src/public/config/color.js